import React from "react";
import { Divider, Grid } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";
import TableRowSkeleton from "./tableRowSkeleton";

const TableSkeleton: React.FC = () => {
  return (
    <Grid container borderRadius={4} bgcolor={"white"} width={"100%"} direction="column" wrap="nowrap">
      <TableRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <TableRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <TableRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <TableRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <TableRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <TableRowSkeleton />
      <Divider flexItem className={cssExports.dividerGray} />
      <TableRowSkeleton />
    </Grid>
  );
};

export default TableSkeleton;
